import deburr from 'lodash/deburr';
import kebabCase from 'lodash/kebabCase';

export const formatMessage = (message, terms) => {
  for (let index = 0; index < terms.length; index++) {
    const searchTerm = `%TERM${index}%`;

    message = message.replace(searchTerm, terms[index]);
  }

  return message;
};

export const replaceSpaces = (text, substitute) => text.replace(/ +/g, substitute);

export const objectToQueryString = obj => Object.entries(obj)
  .map(([key, value]) => {
    if (typeof value === 'object' && !Array.isArray(value)) {
      throw new Error('Please check your params');
    }

    if (!value) {
      return null;
    }

    return `${key}=${value}`;
  })
  .filter(param => param !== null)
  .join('&');

export const capitalize = (value) => {
  if (!value) return null;

  const words = value.toString().split(' ');

  if (!words.length) return null;

  return words.map((word) => {
    if (!word) return '';

    const first = word[0] || '';
    const rest = word.substring(1);

    return first.toUpperCase() + rest.toLowerCase();
  }).join(' ');
}

/**
 * It parses a given URL attaching to it a properly protocol
 * whenever it's inexistent.
 *
 * @param {string} url - The given URL as string.
 * @returns {string} - The final URL with the properly protocol attached when inexistent.
 */
export const formatUrlProtocol = (url) => /^(http|https):\/\//.test(url) ? url : `https://${url}`;

/**
 * It gets a passed value and replaces it's matches
 * with the desired replace value.
 *
 * @param {any} value - The passed value
 * @param {string} searchValue - The value to be matched
 * @param {string} replaceValue - The value to be replaced
 *
 * @returns {string}
 */
export const searchAndReplace = (value, searchValue, replaceValue) => String(value).replace(searchValue, replaceValue);

/**
 * It cleans all accents from the given string and then converts it
 * into 'kebab-case' pattern.
 *
 * @param {String} value The string to be formatted.
 *
 * @returns {String} The resultant string.
 */
export const slugify = (value) => {
  const deburried = deburr(value);

  return kebabCase(deburried);
};

/**
 * It capitalizes every property in a object, including nested ones.
 */
export const capitalizeObject = (obj) => {
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];

    if (typeof value === 'object') {
      acc[key] = capitalizeObject(value);
    } else {
      acc[key] = capitalize(value);
    }

    return acc;
  }, {});
}
